module.exports = __webpack_public_path__ + "whitegrapes.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitegrapes.png
// module id = 890
// module chunks = 0